import FormattedMessage from 'I18n/components/FormattedMessage';
import { H1 } from 'UIComponents/elements/headings';
import { Flow } from 'signup-constants/Flow';
import { Step } from 'signup-constants/Step';
import { devices } from 'signup-constants/styles/viewports.styles';
import styled from 'styled-components';
import { getFlowKey } from '../routing/getFlowKey';
import { isSoftwareSignup } from '../store/flow/selectors';
import { OptionalFormattedMessage } from '../views-components/OptionalFormattedMessage';
import { getLandingPageTitle } from './getLandingPageText';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const StyledH1 = styled(H1).withConfig({
  displayName: "LandingPageTitle__StyledH1",
  componentId: "rshrji-0"
})(["font-size:2.25rem;", " ", " @media ", "{margin-top:40px;", "}@media ", "{margin-top:", ";}"], props => props.$flowKey === Flow.Connect && `font-size: 1.75rem;`, props => props.theme.embedded && ` margin-top: 0;
      font-size: 1.75rem;`, devices.tablet, props => props.isFramedCentredStep && ` margin-top: 0;`, devices.desktop, props => props.isFramedCentredStep ? '20px' : '0');
export const LandingPageSubtitle = styled.div.withConfig({
  displayName: "LandingPageTitle__LandingPageSubtitle",
  componentId: "rshrji-1"
})(["", ""], props => props.theme.embedded && `margin-bottom: 1rem;`);
export const LandingPageTitle = ({
  isMobile,
  isFramedCentredStep = false
}) => {
  const flowKey = getFlowKey();
  const {
    title,
    subtitleLabel
  } = getLandingPageTitle(flowKey);
  const defaultMobileSubtitle = `views.${Step.LandingPage}.mobileSubtitle.default`;
  const getSubtitle = () => {
    return isMobile && isSoftwareSignup() ? defaultMobileSubtitle : subtitleLabel;
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "text-center m-x-auto flex-column justify-center",
    children: [/*#__PURE__*/_jsx(StyledH1, {
      $flowKey: flowKey,
      as: "h1",
      isFramedCentredStep: isFramedCentredStep,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: title
      })
    }), /*#__PURE__*/_jsx(LandingPageSubtitle, {
      children: /*#__PURE__*/_jsx(OptionalFormattedMessage, {
        message: getSubtitle()
      })
    })]
  });
};